import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of} from 'rxjs';
import { Store } from "@ngrx/store";
import { mergeMap} from "rxjs/operators";
import {GuardSelector} from "@core/store/token/token.selectors";
import {ErrorService} from "@services/error.service";

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(private store: Store, private router: Router, private errorService: ErrorService) {}
  canActivate(): Observable<boolean | UrlTree> {
    return this.store.select(GuardSelector).pipe(
      mergeMap(el => {
        if (el) return of(true);
        else {
          const errorMessage = "Non hai i permessi per accedere alla Dashboard.";
          this.errorService.setError(errorMessage);
          this.router.navigateByUrl('/login');
          return of(false);
        }
      })
    );
  }
}
